import styled from '@emotion/styled';
import React from 'react';

import { theme } from '@kindur/components';

import withTracking from '../../components/Common/withTracking';
import { BasicLinkButton } from '../../elements/LinkButton';
import chevron from '../../icons/smartdraw/chevron-black.svg';
import forbesLogo from '../../images/home/forbes.svg';
import quoteIcon from '../../images/home/icon-press.svg';
import colors from '../../styles/colors';

const Container = styled('div')`
  background-color: ${colors.DarkGreen};
  display: flex;
  flex-flow: row nowrap;
  justify-content: stretch;
  align-items: center;
  ${theme.breakpoints.smallTabletDown} {
    height: auto;
    flex-flow: column nowrap;
  }
`;
const Padding = styled('div')`
  padding: 6rem 24px;
  margin: 0 auto;
  max-width: 800px;
  ${theme.breakpoints.tabletDown} {
    padding: 24px 12px 3rem;
  }
`;

const Copy = styled('div')`
  color: #fff;
  font-family: 'DM Sans', sans-serif;
  font-size: 32px;
  font-weight: 700;
  letter-spacing: 0.4px;
  line-height: 48px;
  margin: 24px;
  text-align: center;
  span {
    font-weight: 300;
  }
`;

const Image = styled('img')`
  display: block;
  margin: 0 auto;
  text-align: center;
`;

const TrackComponentName = `SocialProof`;

const SocialProof = ({ content, track }) => {
  return (
    <React.Fragment>
      <Container>
        <Padding>
          <Copy>{content.copy}</Copy>
          <Image src={forbesLogo} alt={`Forbes logo`} />
        </Padding>
      </Container>
    </React.Fragment>
  );
};

SocialProof.displayName = TrackComponentName;

export default withTracking(SocialProof);
